/* eslint-disable no-console */

import $ from 'jquery';

const wrappers = $('.gform_wrapper');
const MARKETING_FORM_WRAPPER_ID = 'gform_wrapper_12';

const closeModal = (modal) => {
    modal.removeClass('is-open').prop('aria-hidden', true);
    modal.find('.modal-close').prop('disabled', true);
    modal.find('input').prop('disabled', true);
    modal.find('#buttonMarketingSubmitNewsletterModal').prop('disabled', true);
}

const openModal = (modal) => {
    modal.addClass('is-open').prop('aria-hidden', false).trigger('focus');
    modal.find('.modal-close').prop('disabled', false);
    modal.find('input').prop('disabled', false);
    modal.find('#buttonMarketingSubmitNewsletterModal').prop('disabled', false);
}

const formSubmitHandler = (form, modal, submitFormEvent) => {
    submitFormEvent.preventDefault();
    window['gf_submitting_12'] = false;

    var data = {
        email: form.find('#input_12_12').val(),
    };

    var options = {
        data,
        async: true,
        method: 'POST',
        url: '/wp-json/amnesty-fi/v1/check-email-opt-out',
    };

    $.ajax(options).done(function(response) {

        // ----------------------------------------------------------------
        // ----------------------------------------------------------------
        // The original thing before things got updated.
        // if (
        //   response && response['userOptOutStatus'] !== 1) {
        //     openModal(modal, response)
        //     return
        // }
        // ----------------------------------------------------------------
        // ----------------------------------------------------------------

        // Conditions to show modal popup:
        // - If user DOES NOT already exist in Salesforce,
        //   show the modal window for them to (ideally)
        //   agree to marketing permissions.
        //
        // - If user HAS NOT agreed to marketing permissions
        //   which may happen if they've submitted before and are
        //   making a subsequent submission, then show the modal
        //   window for them to (ideally) agree to marketing permissions.
        //
        //   Note: Keep in mind that because they have NOT given
        //   their permission the response will (likely) be
        //   empty (or not `1`).
        //
        // Note: At some point in 2025 the `userOptOutStatus`, which
        // comes from ` $result->EmailOptOutValue` in:
        // `Adapters/SalesforcePetitionAdapter` was updated in Salesforce's
        // end to instead talk with Salesforce's "Marketing Permission"
        // checkbox. Since this time, the "Email Opt Out" checkbox in
        // Salesforce acts as a hard "no" that is manually managed by
        // the clients via Salesforce.

        // If the user DOES NOT ALREADY EXIST, which is basically always
        // the case for new users or users who sign up for the first
        // time, then show the modal form.
        if (
          response['userAlreadyExistsStatus'] &&
          response['userAlreadyExistsStatus'] !== 'true'
        ) {
            openModal(modal, response);
            return;
        }

        // If the user HAS OPTED OUT from marketing permissions,
        // which may be the case for users who submitted previously,
        // then show the modal form (to ideally get them to instead
        // opt into the marketing permissions).
        if (
          response['userOptOutStatus'] &&
          response['userOptOutStatus'] === 'true'
        ) {
            openModal(modal, response);
            return;
        }

        // If the user HAS NOT OPTED OUT, or rather, that they
        // previously AGREED to marketing permissions, then check
        // the hidden form input option and set its value before
        // submitting, otherwise the form's default value, which
        // is "no", will always be submitted for subsequent
        // submissions as the modal would only otherwise be shown
        // to new users or users who have opted out of receiving
        // marketing permissions. TLDR: We want to keep users
        // who have previously agreed to marketing permissions.
        else {
          form.find('#input_12_17_1')[0].checked = true;
          form.find('#input_12_17_1')[0].value = 'yes';
        }

        // Submit form after determining the things above.
        form.off('submit').trigger('submit');
    });
}

function initMarketingFormPopup(form, modal) {
    // For some reason, at some point, somehow, Gravity Forms decided to set consent
    // form input values to "1" (Checked state) by default? So set it to false then
    // within on-change function, set it accordingly before submission.
    form.find('#input_12_17_1')[0].checked = false;
    form.find('#input_12_17_1')[0].value = 'no';

    modal.find('input[name=newslettermarketing]').on('change', function() {
        // form.find('#input_12_17').val($(this).val())

        // If user selects that they want to receive newsletters, then
        // set check the consent checkbox.
        if ($(this).val() === 'yes') {
          form.find('#input_12_17_1')[0].checked = true;
          form.find('#input_12_17_1')[0].value = 'yes';
        }
        else {
          form.find('#input_12_17_1')[0].checked = false;
          form.find('#input_12_17_1')[0].value = 'no';
        }
    })

    form.on('submit', function(event) {
        formSubmitHandler(form, modal, event)
    });

    modal.find('.modal-close').on('click', () => {
        closeModal(modal);
    });

    modal.find('#buttonMarketingSubmitNewsletterModal').on('click', () => {
        if (modal.find('[name=newslettermarketing]:checked').length > 0) {
            modal.find('#buttonMarketingSubmitNewsletterModal').prop('disabled', true);
            closeModal(modal);
            form.off('submit').trigger('submit')
        }
    });
}


// Note: At some point the .next() code below stopped working as Gravity Forms had a <script> tag between
// $(this) and the intended .js-newsletter-modal class.
// These things have since been wrapped in divs via themes/amnesty-fi/inc/plugins/gravityforms.php.
// These can also be found with the following classes used there:
// - js-activist-form-wrapper
// - js-activist-form-modal
wrappers.each(function() {
    if ($(this).attr('id') === MARKETING_FORM_WRAPPER_ID) {
        const form = $(this).children('form').eq(0)
        // const modal = $(this).next('.js-newsletter-modal')
        const modal = $(this).closest('.js-activist-form-wrapper').next('.js-activist-form-modal').find('.js-newsletter-modal');
        initMarketingFormPopup(form, modal);
    }
})
